import React from 'react';
import { useTranslation } from 'react-i18next';
import { SourceDetails } from 'features/layout/types';
import { LOCAL_MUTE_ICONS } from 'features/local-mute/icons';
import {
  ClickCallback,
  useTileLocalMute,
} from 'features/streaming/components/controls/useTileLocalMute';

export const useIsolateAudioControl = (source: SourceDetails, clickCallback: ClickCallback) => {
  const { t } = useTranslation('room');
  const { canIsolate, isolate } = useTileLocalMute(source);

  return {
    show: canIsolate,
    icon: LOCAL_MUTE_ICONS.isolateAudio,
    text: t('tooltips.isolate_audio'),
    onClick: (e: React.MouseEvent<HTMLButtonElement | HTMLLIElement, MouseEvent>) => {
      clickCallback?.(e);
      isolate();
    },
  };
};
